<template>
  <div>

    <full-page ref="fullpage" id="fullpage"  :options="options">
    
      <!--First Section-->
      <div class="section" style="margin-top:-0px;">
        <app-header></app-header>
        <div class="bg-video-starter-frame" style="z-index:1; position:absolute; width:100%;height:100%"></div>
        <div class="background-video-wrapper">
          <iframe src="https://player.vimeo.com/video/310521681?background=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
          <v-layout
            column
            fill-height>
            <v-layout class="pan-equal"/>
            <v-layout class="pan-equal"/>
            <v-layout 
              column
              align-center
              justify-center
              class="pan-equal text-over-image-reverse">
              <v-btn  @click="showModal = !showModal" style="z-index:3" outline large color="white">
                {{ $t("homepage.firstSection.cta") }}
                <v-icon style="position:relative;top:-1px;width:16px;">play_arrow</v-icon>
              </v-btn>
            </v-layout>
          </v-layout>
        </div>
      </div>

      <!-- Second Section - RR Collection Section -->
      <div class="section bg-rr-range">
        <v-layout
          column
          fill-height>
          <v-layout
            column
            align-center
            justify-center 
            class="pan-equal text-over-image bright text-xs-center">
            <h1>{{ $t("homepage.rrRangeSection.header") }}</h1>
            <span/>
            <p>{{ $t("homepage.rrRangeSection.paragraph") }}</p>
          </v-layout>
          <v-layout class="pan-equal"/>
          <v-layout class="pan-equal"/>
        </v-layout>
        <div class='icon-scroll' style="bottom:20px;"></div>
      </div>

      <!--Third Section - RR Intense Section -->
      <div class="section bg-rr-intense">
        <v-layout
          column
          fill-height>
          <v-layout
            column
            align-center
            justify-center 
            class="pan-equal text-over-image bright text-xs-center">
            <h1 class="pan-new">{{ $t("homepage.rrIntenseSection.header") }}</h1>
            <span/>
            <p>{{ $t("homepage.rrIntenseSection.paragraph") }}</p>
            <h3 style="margin-top:5px;">{{ $t("homepage.rrIntenseSection.subHeader") }}</h3>
          </v-layout>

          <v-layout class="pan-equal"/>

          <v-layout 
            column
            align-center
            justify-center
            class="pan-equal text-over-image-reverse">
            <router-link to="/youth-activating-cream-intense">
              <v-btn outline large color="white">{{ $t("homepage.rrIntenseSection.cta") }} </v-btn>
            </router-link>
          </v-layout>
        </v-layout>
      </div>

      <!--Fourth Section- RR original section -->
      <div class="section bg-rr">
        <v-layout
          column
          fill-height>
          <v-layout
            column
            align-center
            justify-center 
            class="pan-equal text-over-image bright text-xs-center">
            <h1>{{ $t("homepage.rrOriginalSection.header") }}</h1>
            <span/>
            <p>{{ $t("homepage.rrOriginalSection.paragraph") }}</p>
          </v-layout>
          <v-layout class="pan-equal"/>
          <v-layout 
            column
            align-center
            justify-center
            class="pan-equal text-over-image-reverse">
            <router-link to="/youth-activating-cream">
              <v-btn outline large color="white">{{ $t("homepage.rrOriginalSection.cta") }}
              </v-btn>
            </router-link>
          </v-layout>
        </v-layout>
      </div>

      <!--Fifth Section - RR Eyes -->
      <div class="section bg-rr-eyes">
        <v-layout
          column
          fill-height>
          <v-layout
            column
            align-center
            justify-center 
            class="pan-equal text-over-image bright text-xs-center">
            <h1>{{ $t("homepage.resSection.header") }}</h1>
            <span/>
            <p>{{ $t("homepage.resSection.paragraph") }}</p>
          </v-layout>
          <v-layout class="pan-equal"/>
          <v-layout 
            column
            align-center
            justify-center
            class="pan-equal text-over-image-reverse">
            <router-link to="/rejuvenating-eye-system">
              <v-btn large outline color="white">{{ $t("homepage.resSection.cta") }}
              </v-btn>
            </router-link>
          </v-layout>
        </v-layout>
      </div>


      <!-- 8 Years Masterpiece test -->
      <div class="section pan-row">
        <v-layout>

          <v-flex xs-6 style="background:white;">
      
            <div class="platter-left-container">
              <transition name="platter-left">
                <div v-if="show"> 
                  <img  src="../assets/images/all/platter-left.png" alt="">
                </div>
              </transition>
            </div>
          </v-flex>

          <v-flex xs-6 style="background:black;">
            <div class="platter-right-container">
              <transition name="platter-right">
                <div v-if="show">
                  <img src="../assets/images/all/platter-right.png" alt="">
                </div>
              </transition>
            </div>
          </v-flex>
        </v-layout>
        <transition  name="platter-cta">
          <v-btn class="pan-absolute-center" v-if="show" @click="goToRoute()" outline large  absolute>{{ $t("homepage.masterpiece.cta") }}</v-btn>
        </transition>
      </div>

      <!--Testimonials -->
      <div class="section testimonials ">

        <section class="slide bg-black-marble">
          <div class="pan-column pan-center" style="height:100%;">
            <h1 class="pan-grow-2 pan-column pan-center" style="text-align:center;">{{ $t("homepage.testimonials['WHAT EXPERTS SAY']") }}</h1>
            
            <blockquote class="pan-grow-1 pan-column pan-center">
              <p>"{{ $t("homepage.testimonials['first']") }}"</p>
              <footer>
                <cite>
                  <span>{{ $t("homepage.testimonials['firstCiteName']") }}</span>
                  <span>{{ $t("homepage.testimonials['firstCiteJob']") }}</span>
                </cite>
              </footer>
            </blockquote>
            
            <div class="pan-grow-3"></div>
          </div>
        </section>
        
        <section class="slide bg-black-marble">
          <div class="pan-column pan-center" style="height:100%;">
            <h1 class="pan-grow-2 pan-column pan-center" style="text-align:center;">{{ $t("homepage.testimonials['WHAT EXPERTS SAY']") }}</h1>
            
            <blockquote class="pan-grow-1 pan-column pan-center">
              <p>"{{ $t("homepage.testimonials['second']") }}"</p>
              <footer>
                <cite>                  
                  <span>{{ $t("homepage.testimonials['secondCiteName']") }}</span>
                  <span>{{ $t("homepage.testimonials['secondCiteJob']") }}</span>
                </cite>
              </footer>
            </blockquote>
            <div class="pan-grow-3"></div>
          </div>
        </section>

        <section class="slide bg-black-marble">
          <div class="pan-column pan-center" style="height:100%;">
            <h1 class="pan-grow-2 pan-column pan-center" style="text-align:center;">{{ $t("homepage.testimonials['WHAT EXPERTS SAY']") }}</h1>
            
            <blockquote class="pan-grow-1 pan-column pan-center">
              <p>"{{ $t("homepage.testimonials['third']") }}"</p>
              <footer>
                <cite>
                  <span>{{ $t("homepage.testimonials['thirdCiteName']") }}</span>
                  <span>{{ $t("homepage.testimonials['thirdCiteJob']") }}</span>
                </cite>
              </footer>
            </blockquote>
            
            <div class="pan-grow-3"></div>
          </div>
        </section>

      </div>

      <app-footer class="fp-auto-height" :top="this.$t('homepage.tooltips.one')"></app-footer>
    </full-page>

    <div class="pan-modal-mask" v-if="showModal">
      <div @click="showModal = !showModal" class="pan-modal-container">
        <v-btn outline fab color="white"><v-icon>close</v-icon></v-btn>
        <div class="pan-video-container">
          <div style="padding:56.25% 0 0 0;position:relative;">
            <iframe :src="this.$t('video.link')" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
          </div> 
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import appHeader  from '../components/app-header.vue'
  import appFooter  from '../components/app-footer.vue'

  export default {
    data: function(){
      return {
        show:true,
        showModal: false,
        options: {
          menu: '#menu',
          slidesNavigation: true,
          anchors:[
            this.$t('homepage.tooltips.one'),
            this.$t('homepage.tooltips.two'),
            this.$t('homepage.tooltips.three'),
            this.$t('homepage.tooltips.four'),
            this.$t('homepage.tooltips.five'),
            this.$t('homepage.tooltips.six'),
            this.$t('homepage.tooltips.seven'),
            this.$t('homepage.tooltips.eight') 
          ],
          navigation: true,
          navigationPosition: 'right',
          navigationTooltips: [ 
            this.$t('homepage.tooltips.one'),
            this.$t('homepage.tooltips.two'),
            this.$t('homepage.tooltips.three'),
            this.$t('homepage.tooltips.four'),
            this.$t('homepage.tooltips.five'),
            this.$t('homepage.tooltips.six'),
            this.$t('homepage.tooltips.seven'),
            this.$t('homepage.tooltips.eight')
          ],
          showActiveTooltip: true,
          sectionsColor: ['#00000', '#fff', '#000', '#fff'],
          verticalCentered: false,
          // licence Key
          licenseKey: this.$licenceKey
        }
      }
    },
    components: {
      appHeader,
      appFooter
    },
    methods: {
      goToRoute() {
        this.show = !this.show;
        setTimeout( () => this.$router.push({ path: '/8-year-masterpiece'}), 600);
      }
    }
  }
</script>



<style lang="scss" scoped>

@import '../assets/styles/_vars';

div.section{
  overflow:hidden;
}

.pan-modal-mask{
  z-index:1000;
  width:100%;
  height:100%;
  background:black;
  position:fixed;
  top:0;
  left:0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  .pan-modal-container {
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:center;

    .pan-video-container{
      width:100%;
      max-width:800px;
      margin:0 auto 80px auto;
      padding:20px;
      @media screen and (min-width: $medium){
        margin:40px auto 40px auto;
        max-width:75%;
        max-width:70vw;
      }
    }
  }
}

//Testimonials
.testimonials{
  .slide{
    color:white;
  }
}

//background video wrapper
.background-video-wrapper{ 
  height: 100%;
  iframe{
    pointer-events: none;
    z-index:1;
  }
}


//////Masterpiece
  .platter-left-container,
  .platter-right-container{
    height:100%;
    overflow:hidden;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    &>div{
      img{
        width:200%;
        padding:20px;
        @media screen and (min-width:$xs-screens){
          padding:40px;
        }
        @media screen and (min-width:$s-screens){
          padding:100px;
        }
        @media screen and (min-width: $m-screens){
          width:100%;
          max-width:800px;
          padding:20px;
        }
      }
      position:relative;
      // bottom:-50px;
    }
  }

  .platter-left-container{
    &>div{
      left:0%;
      @media screen and (min-width: $m-screens){
          left:50%;
      }
    }
  }

  .platter-right-container{
    &>div{
      right:100%;
      @media screen and (min-width: $m-screens){
        right:50%;
      }
    }
  }


.platter-left-out-leave{
  transition: all .8s ease-out;
  transform: translate(0%);
}

.platter-left-leave-to{
  transition: all .8s ease-out;
  transform: translate(-200%);
}

.platter-right-leave{
  transition: all .8s ease-out;
  transform: translate(0%);
}

.platter-right-leave-to{
  transition: all .8s ease-out;
  transform: translate(200%);
}


.platter-cta-leave{
  transition: all .8s ease-out;
  opacity:1;
}


.platter-cta-leave-to{
  transition: all .35s ease-out;
  opacity:0;
}


</style>



